// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1zc5f","title":"Info_title__E8mxJ","links":"Info_links__1FojE","link":"Info_link__1RKpP","logo":"Info_logo__1R3oq"};